import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';

import AddPomInfo from '@features/pom/components/AddPomInfo';
import ImageSlider from '@features/pom/components/ImageSlider';
import PomViewModal from '@features/pom/components/PomViewModal';

import { checkUserType, getShortName, ORGANIZTION_INFO } from '@utils/Util';

const TableView = ({ pomList, onDeletePomFromList, selectedBrand }) => {
	const [selectedImage, setSelectedImage] = useState([]);
	const [editId, setEditId] = useState(null);
	const [selectedPom, setSelectedPom] = useState(null);
	const isCompared = selectedBrand?.length > 0;

	return (
		<div className="data-table  scroll-x-label">
			<div className="compair-table ">
				<table className="table with-border height-sm no-hover ">
					<thead>
						<tr>
							<th>POM Visual</th>
							<th>Body Part</th>
							<th>Brand</th>
							<th>POM Code & POM</th>
							<th>How to measure</th>
							<th>Tolerance (CM)</th>
							<th>Other Info</th>
							<th>Comments</th>
							{checkUserType('ADMIN') && <th></th>}
						</tr>
					</thead>
					<tbody>
						{pomList?.map((item) => {
							const NITEX_DATA = item?.brandDetailsResponseList?.find(
								(item) => item?.brandResponse?.name === 'NITEX'
							);
							const filteredBrands = item?.brandDetailsResponseList?.filter(
								(brandDetail) =>
									selectedBrand?.some(
										(brand) => brand.value === brandDetail?.brandResponse?.id
									) && brandDetail?.brandResponse?.id !== NITEX_DATA?.id
							);
							const noOfRowSpan = filteredBrands?.length + 1;
							return (
								<>
									<tr className="cursor-pointer" key={item.id}>
										<td className="visual-td" rowSpan={isCompared ? noOfRowSpan : 1}>
											<ImageSlider
												type="TABLE_VIEW"
												imageList={item?.visualResponseList}
												item={item}
												selectedImage={selectedImage}
												setSelectedImage={setSelectedImage}
											/>
										</td>

										<td
											className="pom-code body-part"
											rowSpan={isCompared ? noOfRowSpan : 1}
											onClick={() => setSelectedPom(item?.id)}
										>
											<div>
												{item?.isNew && (
													<span className="status cyan-4 mb-1">new</span>
												)}
												{item?.brandOnly && (
													<span className="gray_dark_01 status gray-2 rounded-0 mt-1 mb-1">
														Only :{' '}
														{
															item?.brandDetailsResponseList?.find(
																(item) =>
																	item?.brandResponse?.name !== 'NITEX'
															)?.brandResponse?.name
														}
													</span>
												)}
												<p>{item?.bodyPart?.name}</p>
											</div>
										</td>
										<td onClick={() => setSelectedPom(item?.id)} className="brand-td">
											{ORGANIZTION_INFO?.name}
										</td>
										<td
											className="pom-code pom-code-pom"
											onClick={() => setSelectedPom(item?.id)}
										>
											<div>
												<p className="medium-14 weight-500 gray_dark_01">
													{NITEX_DATA?.pomCode}
												</p>
												<p className="regular-12">{NITEX_DATA?.pomName}</p>
											</div>
										</td>

										<td onClick={() => setSelectedPom(item?.id)} className="measure-td">
											<p>{NITEX_DATA?.howToMeasure}</p>
										</td>

										<td onClick={() => setSelectedPom(item?.id)} className="tolerance-td">
											{NITEX_DATA?.tolerance !== 0 && NITEX_DATA?.tolerance}
										</td>

										<td
											onClick={() => setSelectedPom(item?.id)}
											className="other-info"
											rowSpan={isCompared ? noOfRowSpan : 1}
										>
											<p className="d-block regular-14 gray_dark_02">
												Category:{' '}
												<Tooltip
													title={
														<span className="regular-12">
															{item?.allCategory
																? 'All'
																: item?.subCategoryResponseList
																		?.map((category) => category?.name)
																		.join(', ')}
														</span>
													}
													placement="top"
													arrow
												>
													<span className="gray_dark_01 pl-2">
														{item?.allCategory
															? 'All'
															: getShortName(
																	item?.subCategoryResponseList
																		?.map((category) => category?.name)
																		.join(', '),
																	20
																)}
													</span>
												</Tooltip>
											</p>

											<p className="d-block regular-14 gray_dark_02">
												Market:{' '}
												<Tooltip
													title={
														<span className="regular-12">
															{item?.allMarket
																? 'All'
																: item?.marketList
																		?.map((market) => market?.name)
																		.join(', ')}
														</span>
													}
													placement="top"
													arrow
												>
													<span className="gray_dark_01 pl-2">
														{item?.allMarket
															? 'All'
															: getShortName(
																	item?.marketList
																		?.map((market) => market?.name)
																		.join(', '),
																	20
																)}
													</span>
												</Tooltip>
											</p>

											<p className="d-block regular-14 gray_dark_02">
												TBO:{' '}
												<span className="gray_dark_01 pl-2">
													{item?.parentCategory?.name}
												</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												Position:{' '}
												<span className="gray_dark_01 pl-2">
													{item?.position?.name}
												</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												Serial:{' '}
												<span className="gray_dark_01 pl-2">{item?.serial}</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												POM Size:{' '}
												<span className="gray_dark_01 pl-2">{item?.size?.name}</span>
											</p>
											<p className="d-block regular-14 gray_dark_02">
												Side:{' '}
												<span className="gray_dark_01 pl-2">{item?.side?.name}</span>
											</p>
										</td>

										<td
											className="comments-td"
											onClick={() => setSelectedPom(item?.id)}
											rowSpan={isCompared ? noOfRowSpan : 1}
										>
											<p>{item?.comment}</p>
										</td>
										{checkUserType('ADMIN') && (
											<td rowSpan={isCompared ? noOfRowSpan : 1}>
												{' '}
												<div className="edit-items">
													<div className="option">
														<div className="dropdown">
															<button
																className="btn btn-default dropdown-toggle"
																type="button"
																id="menu1"
																data-toggle="dropdown"
																aria-expanded="false"
															>
																<img
																	src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
																	alt="tee"
																/>
															</button>
															<ul
																className="dropdown-menu dropdown-menu-right shadow-lg"
																role="menu"
																aria-labelledby="menu1"
																x-placement="bottom-end"
															>
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																	onClick={() => setEditId(item?.id)}
																>
																	<span className="font-weight-normal  text-black">
																		Edit
																	</span>
																</li>

																<li
																	role="presentation"
																	className="px-4 pb-3"
																	onClick={() =>
																		onDeletePomFromList(item?.id)
																	}
																>
																	<span className="font-weight-normal  text-black">
																		Delete
																	</span>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</td>
										)}
									</tr>

									{isCompared &&
										filteredBrands?.map((data) => (
											<tr key={data?.id}>
												<td onClick={() => setSelectedPom(item?.id)}>
													{data?.brandResponse?.name}
												</td>
												<td
													className="pom-code"
													onClick={() => setSelectedPom(item?.id)}
												>
													<p className="medium-14 weight-500 gray_dark_01">
														{data?.pomCode}
													</p>
													<p className="regular-12">{data?.pomName}</p>
												</td>
												<td onClick={() => setSelectedPom(item?.id)}>
													{data?.howToMeasure}
												</td>
												<td onClick={() => setSelectedPom(item?.id)}>
													{data?.tolerance !== 0 && item?.tolerance}
												</td>
											</tr>
										))}
								</>
							);
						})}
					</tbody>
				</table>
			</div>
			{editId && <AddPomInfo type="EDIT" onClose={() => setEditId(null)} editId={editId} />}
			{selectedPom && <PomViewModal pomId={selectedPom} onClose={() => setSelectedPom(null)} />}
		</div>
	);
};

export default TableView;
